import { Icon, Button } from 'semantic-ui-react';

/**
 * Action buttons for uploading and capturing person images
 */
const ActionButtons = ({
    fileInputRef,
    onFileInputClick,
    onTakePicture,
    onLocalFileUpload,
    isOperationInProgress
}) => {
    return (
        <div className="action-buttons">
            <Button
                color="teal"
                onClick={onFileInputClick}
                className="action-btn"
                disabled={isOperationInProgress}
            >
                <Icon name="upload" />
                Upload Photo
            </Button>

            <Button
                color="blue"
                onClick={onTakePicture}
                className="action-btn"
                disabled={isOperationInProgress}
            >
                <Icon name="camera" />
                Take Picture
            </Button>

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={onLocalFileUpload}
                style={{ display: 'none' }}
            />
        </div>
    );
};

export default ActionButtons;
